import React, { Component } from "react";
import styled from "styled-components";

const LedContainer = styled.div`
  width: calc(100% / 32);
  height: calc(100% / 32);
  position: relative;
  display: block;
  background: #fff;
  border-radius: 15%;
`;

const LedElement = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: block;
`;

interface Props {
  color: string;
}

export default class Led extends Component<Props> {
  shouldComponentUpdate(nextProps) {
    // Don't update if the color hasn't changed
    // Decreases browser scripting time by 10x on click
    if (this.props.color !== nextProps.color) {
      return true;
    }
    return false;
  }

  render() {
    let background = this.props.color;

    return (
      <LedContainer>
        <LedElement style={{ background }} />
      </LedContainer>
    );
  }
}
